document.addEventListener('DOMContentLoaded', () => {
    const vvNotificationButton = document.getElementById("vv-notification-toggle");
    const vvNotificationElement = document.getElementById("vv-notification-container");
    const vvNotificationClose = document.getElementById("vv-notification-close");
    const vvDropdownList = document.querySelectorAll(".vv-dropdown-list");
    var vvNotificationCount = '';
    const vvHeader = document.getElementById('shopify-section-header');
    const vvUnreadNotification = [];
    if (vvDropdownList.length > 0) {
        const vvNotificationBubble = document.createElement('vv-notification-count');
        vvNotificationBubble.classList.add('vv-notification-count', 'header__cart-count--floating', 'vv-notification-bubble-count')
        vvNotificationButton.append(vvNotificationBubble);
        vvNotificationButton.style.display = 'flex';
        vvNotificationCount = vvNotificationButton.querySelector(".vv-notification-bubble-count");
    }



    function vvToggleBubbleVisibility() {
        vvDropdownList.forEach((element) => {
            const vvListId = element.id;
            const vvNotificationKey = `vv-notification--${vvListId}`;
            const isNotificationSet = localStorage.getItem(vvNotificationKey);
            isNotificationSet ? vvNotificationCount.style.visibility = "hidden" : (vvUnreadNotification.push(vvListId), vvNotificationCount.innerHTML = vvUnreadNotification.length, vvNotificationCount.style.visibility = "visible");
        });
    }
    vvToggleBubbleVisibility();

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const vvNotificationKey = `vv-notification--${entry.target.id}`;
                const isNotificationSet = localStorage.getItem(vvNotificationKey);
                isNotificationSet ? entry.target.children[0].hidden = true : (localStorage.setItem(vvNotificationKey, true), entry.target.children[0].hidden = false);
            }
        });
    }, { threshold: 0.5 });

    vvDropdownList && vvDropdownList.forEach((element) => observer.observe(element));

    if (vvNotificationButton && vvNotificationElement) {
        vvNotificationButton.addEventListener("click", () => {
            const isNotificationVisible = vvNotificationElement.style.display === "block";

            if (!isNotificationVisible || vvNotificationElement.style.display === "") {
                vvNotificationElement.style.display = "block";
                vvUpdateNotificationPosition();
                vvNotificationElement.style.animation = 'vvFadeInDown 0.5s ease forwards';
            } else {
                vvNotificationElement.style.animation = 'vvFadeOutUp 0.5s ease forwards';
                setTimeout(() => {
                    vvToggleBubbleVisibility();
                    vvNotificationElement.style.display = "none";
                }, 500);
            }
        });

        document.addEventListener('click', () => {
            if (vvNotificationElement && !vvNotificationElement.contains(event.target) && !vvNotificationButton.contains(event.target) && vvNotificationElement.style.display === "block") {
                vvNotificationElement.style.animation = 'vvFadeOutUp 0.5s ease forwards';
                setTimeout(() => {
                    vvToggleBubbleVisibility();
                    vvNotificationElement.style.display = "none";
                }, 500);
            }
        });
    }

    vvNotificationElement && vvNotificationClose && vvNotificationClose.addEventListener("click", () => {
        vvNotificationElement.style.animation = 'vvFadeOutUp 0.5s ease forwards';
        setTimeout(() => {
            vvToggleBubbleVisibility();
            vvNotificationElement.style.display = "none";
        }, 500);
    });

    function vvUpdateNotificationPosition() {
        var gap = 14;
        // offsetWidth is the popup's real layout width (valid once displayed).
        var popupWidth = vvNotificationElement.offsetWidth;

        vvNotificationElement.style.position = 'fixed';
        vvNotificationElement.style.margin = '0';

        // top/left are the popup's exact top-left corner: no centering transform
        // is involved, so the position no longer depends on the popup's height.
        if (window.innerWidth >= 1000) {
            // Desktop: drop down from just beneath the bell, right edges aligned.
            var bellRect = vvNotificationButton.getBoundingClientRect();
            var deskLeft = bellRect.right - popupWidth;
            if (deskLeft < 16) deskLeft = 16;
            vvNotificationElement.style.left = deskLeft + 'px';
            vvNotificationElement.style.top = (bellRect.bottom + gap) + 'px';
        } else {
            // Mobile: centered, dropping just below the (sticky) header so it
            // stays anchored to the bell row whatever the header's height.
            var headerBottom = vvHeader ? vvHeader.getBoundingClientRect().bottom : 0;
            if (headerBottom < 0) headerBottom = 0;
            var mobileLeft = (window.innerWidth - popupWidth) / 2;
            vvNotificationElement.style.left = mobileLeft + 'px';
            vvNotificationElement.style.top = (headerBottom + gap) + 'px';
        }
    }
    if (vvNotificationElement) {
        vvUpdateNotificationPosition();
        window.addEventListener('resize', function () {
            vvUpdateNotificationPosition();
        });
        window.addEventListener('scroll', function () {
            if (vvNotificationElement.style.display === 'block') {
                vvUpdateNotificationPosition();
            }
        });
    }
});